/**
 * One click on a MAJOR-only hold (ruling 33, 2026-09-29).
 *
 * Re-judge queues a durable re-gate job after the operator's edit; only a
 * clean verdict releases, attributed to the operator. Filings only — a
 * synthesis article's evidence is not persisted. Accept records the
 * operator's word on a non-blocking finding and releases if that lifts the
 * hold.
 */
import { apiClient } from './config.js';

export interface RejudgeQueued {
  job_id: string;
  /** False when a re-judge for this article was already pending. */
  created: boolean;
}

export interface RejudgeStatus {
  status: 'pending' | 'running' | 'retrying' | 'completed' | 'failed';
  result: {
    skipped?: string;
    old_verdict?: string;
    new_verdict?: string;
    released?: boolean;
    publish?: { queued: boolean; reason?: string } | null;
  } | null;
  error: string | null;
  attempts: number;
}

export interface FindingAccepted {
  verdict: string;
  previous_verdict: string;
  released: { queued: boolean; reason?: string } | null;
}

export async function rejudgeArticle(articleId: string): Promise<RejudgeQueued> {
  const { data } = await apiClient.post<RejudgeQueued>(`/articles/${articleId}/rejudge`);
  return data;
}

export async function getRejudgeStatus(articleId: string, jobId: string): Promise<RejudgeStatus> {
  const { data } = await apiClient.get<RejudgeStatus>(`/articles/${articleId}/rejudge/${jobId}`);
  return data;
}

export async function acceptFinding(
  articleId: string,
  issueIndex: number,
  reason: string,
  expectedUpdatedAt?: string | null,
): Promise<FindingAccepted> {
  const { data } = await apiClient.post<FindingAccepted>(
    `/articles/${articleId}/findings/${issueIndex}/accept`,
    { reason, expected_updated_at: expectedUpdatedAt ?? undefined },
  );
  return data;
}
